import $ from 'jquery';
import React, {useState, useEffect} from 'react';
import SessionManager from '../../routes/SessionManager';
import Loading from '../Loading';

function ZoneHistoryImage (props) {

    var sessionMgr = new SessionManager();
    let user = sessionMgr.readCookie('user');

    const [zoom, setZoom] = useState(1);
    const [zoom_in, setZoomIn] = useState(true);
    const [image, setImage] = useState(props.zone_hisory_rec.image);
    const [findObjects, setFindObjects] = useState(props.find_objects);

    useEffect(() => {
        if (props.find_objects) {
            applyBoundingBoxes()
        }

        $('.close').on('click', () => {
            if ($(window).width() <= 768)
                return;
            setZoom(1.75);
            setZoomIn(false);
            zoomInOut();
        });
    }, []);

    useEffect(() => {
        // this.setState({ zoom: 1, zoom_in: true }, this.resetZoom);
        setZoom(1);
        setZoomIn(true);

        $("#recognizeObjects:parent > .bbox").remove();
        setImage(props.zone_hisory_rec.image);
        setFindObjects(props.find_objects);
        if (findObjects)
            applyBoundingBoxes();

    }, [props]);

    const applyBoundingBoxes = () => {
        resetZoom();
        let currentImage = $("#recognizeObjects");
        let bb_data = props.zone_hisory_rec.bbox_info ? JSON.parse(props.zone_hisory_rec.bbox_info) : null
        if (bb_data) {
            try {
                for (var bb of bb_data) {
                    var w = $(currentImage).parent().width()
                    var h = $(currentImage).parent().height();

                    var div = document.createElement('div');
                    div.className = 'bbox bbox_' + bb.c;
                    div.setAttribute("style", "position: absolute; border: 2px solid #1dec23; width:" + (w * bb['w']) + "px; height:" + (h * bb['h']) + "px; top:" + (h * bb['y']) + "px; left:" + (w * bb['x']) + "px")
                    $(div).appendTo($(currentImage).parent());
                }

                setFindObjects(false);

            } catch (e) { }
        }

    }

    // componentWillReceiveProps(nextProps) {
    //     if (this.props.image !== nextProps.zone_hisory_rec.image) {
    //         $("#recognizeObjects:parent > .bbox").remove();
    //         this.setState({ image: nextProps.zone_hisory_rec.image, findObjects: nextProps.find_objects }, () => {
    //             if (this.state.findObjects)
    //                 this.applyBoundingBoxes()
    //         });
    //     }
    // }
    const resetZoom = () => {
        if ($(window).width() <= 768)
            return;
        $('#recognizeObjects').css({ width: '100%', marginTop: 0, marginLeft: 0 });
    }

    const zoomInOut = (e) => {
        if ($(window).width() <= 768)
            return;

        let containerHeight = $('#recognizeObjects').parent().height();
        let z = zoom;
        let zoomIn = zoom_in;
        z = zoomIn ? z + 0.75 : z - 0.75;

        let xy = e ? [
            e.pageX - $('#recognizeObjects').parent().offset().left,
            e.pageY - $('#recognizeObjects').parent().offset().top
        ] : [0, 0];

        if (z > 2.5)
            zoomIn = false;

        if (z === 1)
            zoomIn = true;

        console.log({ zoom: z, zoom_in: zoomIn });
        $('#recognizeObjects').css({ width: $('#recognizeObjects').parent().width() * z });

        let m = { marginTop: -(xy[1] * z - xy[1]), marginLeft: -(xy[0] * z - xy[0]) };
        $('#recognizeObjects').css(m);
        $('#recognizeObjects').parent().height(containerHeight);
        setZoom(z);
        setZoomIn(zoomIn);

        if (z !== 1) {
            $('.bbox').hide();
        } else {
            $('.bbox').show();
        }
    }

    return (
        <React.Fragment>
            <div className="modal-header p-2 bg-primary text-white">
                {!findObjects && <span className="modal-title">{user.zone_selected.location_name} <small className="ml-5">{props.zone_rec_timestamp}</small></span>}
                {findObjects && <Loading>Image Recognition In Progress ...</Loading>}
                <button type="button" className="far fa-lg fa-times-circle" data-dismiss="modal" aria-label="Close" onClick={props.closeModal}>

                </button>
            </div>
            <div className="modal-body p-0 m-0">
                <img onLoad={() => applyBoundingBoxes()} onClick={zoomInOut} id="recognizeObjects" style={{ cursor: zoom_in ? 'zoom-in' : 'zoom-out' }} className="card-img-top card-img-top-border-0 border border-0" src={image} alt='AI Recognition' />
            </div>
        </React.Fragment>
    );
}

export default ZoneHistoryImage;